import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  inject,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import {FCanvasComponent, FCreateConnectionEvent} from "@foblex/flow";
import {Observable, Subscription} from "rxjs";
import {select, Store} from "@ngrx/store";
import {AppState} from "../../../store/reducers";
import {
  ApprovalFlowStages
} from "../../../store/entities/instution-settings/approval-flow-stages/approval-flow-stages.model";
import {ConcatPipe} from "../../pipes/concat.pipe";
import {
  selectModifiedApprovalFlowStages
} from "../../../store/entities/instution-settings/approval-flow-stages/approval-flow-stages.selectors";


@Component({
  selector: 'app-flow-chart',
  templateUrl: './flow-chart.component.html',
  styleUrl: './flow-chart.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FlowChartComponent implements OnInit {

  private store: Store<AppState> = inject(Store<AppState>)

  @Output() newConnection = new EventEmitter<{ from: string; to: string }>()

  @ViewChild(FCanvasComponent, {static: true})
  public fCanvas!: FCanvasComponent;
  public connections: { from: string, to: string }[] = [];


  approvalFlowStages$: Observable<ApprovalFlowStages[]>;
  subscriptions$: Subscription = new Subscription();

  orderedApprovalFlowStages: ApprovalFlowStages[] = [];

  constructor(
    private changeDetectorRef: ChangeDetectorRef
  ) {
  }

  ngOnInit() {
    this.approvalFlowStages$ = this.store.pipe(select(selectModifiedApprovalFlowStages))
    this.subscriptions$.add(this.approvalFlowStages$.subscribe(stages => {
      if (stages?.length) {

        console.log(stages, 'ALL STAGES');


        this.orderedApprovalFlowStages = []
        this.connections = []
        let unOrderedApprovalFlowStages: ApprovalFlowStages[] = [...stages]

        // Add first stage
        let firstStageIndex = unOrderedApprovalFlowStages?.findIndex(s => s.stageIsStarting)
        let firstStage = unOrderedApprovalFlowStages?.find(s => s.stageIsStarting)
        if (firstStageIndex >= 0) {
          this.orderedApprovalFlowStages.push({...unOrderedApprovalFlowStages[firstStageIndex]})
          unOrderedApprovalFlowStages.splice(firstStageIndex, 1)
        }

        if (firstStage) {
          if (firstStage?.successorStage?.id) {
            this.connections.push({from: `o_${new ConcatPipe().transform(firstStage.stageName)}`, to: `i_${new ConcatPipe().transform(firstStage?.successorStage?.stageName)}`})
          }
          if (unOrderedApprovalFlowStages?.length) {
            this.arrange(unOrderedApprovalFlowStages, new ConcatPipe().transform(firstStage?.successorStage?.stageName))
          }
        } else {
          const initialStage = {...unOrderedApprovalFlowStages[0]};
          this.orderedApprovalFlowStages.push(initialStage)
          unOrderedApprovalFlowStages.splice(0, 1)
          if (initialStage?.successorStage?.id) {
            this.connections.push({
              from: `o_${new ConcatPipe().transform(initialStage.stageName)}`,
              to: `i_${new ConcatPipe().transform(initialStage?.successorStage?.stageName)}`
            })
          }
          if (unOrderedApprovalFlowStages?.length) {
            this.arrange(unOrderedApprovalFlowStages, new ConcatPipe().transform(initialStage?.successorStage?.stageName))
          }
        }

        this.changeDetectorRef.detectChanges()

      }
    }))
  }

  arrange(items: ApprovalFlowStages[], successorUniqueId: string = null) {
    if (successorUniqueId) {
      let successorStageIndex = items?.findIndex(s => new ConcatPipe().transform(s.stageName) === successorUniqueId)
      if (successorStageIndex >= 0) {
        let successorStage = {...items[successorStageIndex]}
        this.orderedApprovalFlowStages.push(successorStage)
        items.splice(successorStageIndex, 1)

        if (items?.length) {
          if (successorStage?.successorStage?.id) {
            this.connections.push({
              from: `o_${new ConcatPipe().transform(successorStage.stageName)}`,
              to: `i_${new ConcatPipe().transform(successorStage?.successorStage?.stageName)}`
            })
          }
          this.arrange(items, new ConcatPipe().transform(items[successorStageIndex]?.successorStage?.stageName))
        }
      }
    } else {
      // find stages with successor to order the first
      const stageWithSuccessorIndex = items?.findIndex(s => s.successorStage?.id)
      if (stageWithSuccessorIndex >= 0) {

        const stageWithSuccessorStage: ApprovalFlowStages = {...items[stageWithSuccessorIndex]}
        this.connections.push({
          from: `o_${new ConcatPipe().transform(stageWithSuccessorStage.stageName)}`,
          to: `i_${new ConcatPipe().transform(stageWithSuccessorStage?.successorStage?.stageName)}`
        })
        this.orderedApprovalFlowStages.push(stageWithSuccessorStage)
        items.splice(stageWithSuccessorIndex, 1)
        if (items?.length) {
          this.arrange(items, new ConcatPipe().transform(stageWithSuccessorStage?.successorStage?.stageName))
        }
      } else {
        const stageWithoutSuccessorStage: ApprovalFlowStages = {...items[0]}
        this.orderedApprovalFlowStages.push(stageWithoutSuccessorStage)
        items.splice(0, 1)
        if (items?.length) {
          this.arrange(items, null)
        }
      }
    }
  }

  public onLoaded(): void {
    this.fCanvas.resetScaleAndCenter(false);
  }

  public onCreateConnection(event: FCreateConnectionEvent): void {
    if (!event.fInputId) {
      return;
    }
    this.connections.push({from: event.fOutputId, to: event.fInputId});
    this.newConnection.emit({from: event.fOutputId?.replace('o_', ''), to: event.fInputId?.replace('i_', '')})
  }


  public onDeleteConnections(): void {
    this.connections = [];
    this.changeDetectorRef.detectChanges();
  }

}
